// extracted by mini-css-extract-plugin
export default {"productGallery":"eN-z","inQuickShop":"fN-z"};